<template>
  <div class="container" style="flex-direction: row;flex:1;">
    <div v-show="showLeft" ref="left" :style="Object.assign({flex:'auto',overflow: 'hidden'}, leftStyle)">
      <slot name="left" />
    </div>
    <div
      v-show="showLeft&&showRight"
      ref="division"
      class="division"
      :style="{width:divisionW+'px'}"
      @mousedown="enabled=true"
    >
      <span>‖</span>
    </div>
    <div v-show="showRight" ref="right" :style="Object.assign({flex:'auto',overflow: 'hidden'}, rightStyle)">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'CargoLeftRightResize',
  props: {
    showLeft: {
      type: Boolean,
      default: true
    },
    leftStyle: {
      type: Object,
      default: () => { return {} }
    },
    showRight: {
      type: Boolean,
      default: true
    },
    rightStyle: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      enabled: false,
      divisionW: 10,
      doc: new DocumentManage()
    }
  },
  computed: {
    divisionHalfW() {
      return this.divisionW / 2
    }
  },
  created() {
    this.doc.set('dragging', e => {
      if (!this.enabled) {
        return
      }
      this.dragging(e)
    })
    this.doc.set('endDrag', () => {
      document.getElementById('app').classList.remove('disabled-select')
      this.enabled = false
    })
    this.doc.set('windowResize', () => {
      if (this.$refs.left && this.showLeft && this.$refs.right && this.showRight) {
        if (this.leftStyle.width) {
          this.$refs.left.style.width = this.leftStyle.width
        } else {
          this.$refs.left.style.width = ''
        }
        if (this.rightStyle.width) {
          this.$refs.right.style.width = this.rightStyle.width
        } else {
          this.$refs.right.style.width = ''
        }
      }
    })
  },
  mounted() {
    document.addEventListener('mousemove', this.doc.get('dragging'), false)
    document.addEventListener('mouseup', this.doc.get('endDrag'), false)
    document.addEventListener('mouseleave', this.doc.get('endDrag'), false)
    // window.addEventListener('resize', this.doc.get('windowResize'))
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.doc.get('dragging'), false)
    document.removeEventListener('mouseup', this.doc.get('endDrag'), false)
    document.removeEventListener('mouseleave', this.doc.get('endDrag'), false)
    // window.removeEventListener('resize', this.doc.get('windowResize'))
    this.doc.destory()
  },
  methods: {
    dragging(e) {
      document.getElementById('app').classList.add('disabled-select')
      const left = this.$refs.left
      const leftRect = left.getBoundingClientRect()
      const right = this.$refs.right
      const rightRect = right.getBoundingClientRect()
      if (e.clientX <= leftRect.left + this.divisionHalfW) {
        return
      }
      if (e.clientX >= rightRect.right - this.divisionHalfW) {
        return
      }
      const leftW = (e.clientX - this.divisionHalfW) - leftRect.left
      const rightW = rightRect.right - (e.clientX + this.divisionHalfW)
      left.style.width = leftW + 'px'
      right.style.width = rightW + 'px'
      this.$emit('onSize', { leftW: leftW + 'px', rightW: rightW + 'px' })
    },
    // 隐藏左边（外部调用）
    hideLeft() {
      this.$refs.left.style.display = 'none'
      this.$refs.division.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
}
.division {
  cursor: ew-resize;
  display: flex;
  flex-direction: column;
}
.division span {
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding-left: 1px;
  font-size: 18px;
  color: #bdbdbd;
}
</style>
